import article from '@/api/article';
import * as types from './mutationTypes';

export default {
  fetchDefaultArticles({ commit, state }, query) {
    commit(types.START_FETCH_ARTICLES, { query });

    return article
      .getArticles({
        ...state.query,
      })
      .then((articles) => {
        commit(types.SET_FETCHED_ARTICLES, articles);
      })
      .catch((e) => {
        commit(types.FETCH_ARTICLES_ERROR, `failed get articles: ${e}`);
      });
  },

  fetchMoreArticles({ commit, state }) {
    commit(types.START_FETCH_MORE_ARTICLES);
    const fetchMoreQuery = state.query;
    fetchMoreQuery.page += 1;

    return article
      .getArticles({
        ...fetchMoreQuery,
      })
      .then((articles) => {
        if (articles.length > 0) {
          commit(types.APPEND_FETCHED_ARTICLES, articles);
        } else {
          commit(types.FETCHED_NULL_ARTICLES);
        }
      })
      .catch((e) => {
        commit(types.FETCH_ARTICLES_ERROR, `failed get articles: ${e}`);
      });
  },

  fetchArticleById({ commit }, postid) {
    commit(types.START_FETCH_SINGLE_ARTICLE);

    return article
      .getArticlesById({
        postid,
      })
      .then((fetchedarticle) => {
        commit(types.FETCHED_ARTICLE, fetchedarticle);
      })
      .catch((e) => {
        commit(types.FETCH_ARTICLES_ERROR, `failed get articles: ${e}`);
      });
  },

  updateSingleArticle({ commit }, singleArticle) {
    commit(types.START_FETCH_SINGLE_ARTICLE);
    return commit(types.FETCHED_ARTICLE, singleArticle);
  },

  updateFilter({ dispatch, commit }, filters) {
    Object.keys(filters).forEach((filterKey) => {
      commit(types.SET_FILTER, {
        [filterKey]: filters[filterKey],
      });
    });

    let icsToFetch = null;
    switch (filters.icsType) {
      case 'i':
        icsToFetch = 'industrial';
        break;
      case 'c':
        icsToFetch = 'commercial';
        break;
      case 's':
        icsToFetch = 'shop';
        break;
      case '':
        icsToFetch = 'ici';
        break;
      default:
        break;
    }

    const query = {
      articleType: filters.articleType,
      columnsCategory: filters.columnsCategory,
      ics: `mr-${icsToFetch}`,
      limit: 30,
      page: 1,
      keyword: filters.keyword,
    };
    if (filters.articleType === 'columns') {
      query.ics = filters.columnsCategory;
    }
    return dispatch('fetchDefaultArticles', query);
  },

  setIcsType({ commit }, payload) {
    commit(types.SET_ICS_TYPE, payload);
  },
};
